import React from "react";
import sortArray from "../functions/sortArray";
import {
    Box,
    Button,
    Card,
    Collapsible,
    Form,
    FormField,
    Text,
    TextInput,
} from "grommet";
import { CircleInformation, Close, EmptyCircle, Search } from "grommet-icons";
import { BsChevronContract, BsChevronExpand } from "react-icons/bs";
import BookList from "./BookList";

const BookGroupList = (props: any) => {
    let groupData = props.groupData;
    let groupList = props.groupList;

    // console.log("groupData", groupData)
    // console.log("groupList", groupList)

    const [groupOpen, setGroupOpen] = React.useState<any>({});

    React.useEffect(() => {
        let gOpen: { [key: string]: boolean } = {};
        groupList.forEach((g: any) => {
            gOpen[g] = true;
        });
        setGroupOpen(gOpen);
        console.log("groupData", groupData);
    }, []);

    const [groupFiltered, setGroupFiltered] = React.useState<any>(groupList);
    const [filterText, setFilterText] = React.useState("");

    React.useEffect(() => {
        if (filterText === "") {
            setGroupFiltered(groupList);
        } else {
            console.log("filterText", filterText);
            let gFiltered = groupList.filter((g: any) => {
                let isreturn = false;
                let gname = g;
                let booklist = groupData[gname];

                booklist.forEach((b: any) => {
                    if (b.book_title && b.book_title.includes(filterText)) {
                        isreturn = true;
                    } else if (
                        b.book_title_ko &&
                        b.book_title_ko.includes(filterText)
                    ) {
                        isreturn = true;
                    } else if (
                        b.publisher &&
                        b.publisher.includes(filterText)
                    ) {
                        isreturn = true;
                    }
                });
                if (isreturn) {
                    return g;
                }
            });
            setGroupFiltered(gFiltered);
        }
    }, [filterText]);

    const GroupTitle = (props: any) => {
        const { gname } = props;
        let title_div = gname.split("<");
        let title = title_div[0];
        let title_info = "";
        if (title_div.length > 1) {
            title_info = title_div[1].replace(">", "");
        }
        return (
            <>
                <Text size="15px" margin="1px">
                    {" "}
                    {title}
                </Text>
                {title_info !== "" && (
                    <Text margin={{ left: "5px" }} size="13px" color="grey">
                        {title_info}
                    </Text>
                )}
            </>
        );
    };

    const GroupUnit = (props: any) => {
        const { gname } = props;
        // console.log("group unit", gname)
        const openAll = props.open;
        const closeAll = props.close;
        const [open, setOpen] = React.useState(true);

        React.useEffect(() => {
            setOpen(true);
        }, [gname]);

        React.useEffect(() => {
            if (openAll) {
                setOpen(true);
            }
            if (closeAll) {
                setOpen(false);
            }
        }, [openAll, closeAll]);

        return (
            <Box
                width="full"
                height="full"
                align="start"
                justify="start"
                pad={{ horizontal: "10px" }}
                margin="10px"
                round="0"
                background="rgb(255,255,255,0.8)"
                flex={false}
            >
                <Box
                    direction="row"
                    width="full"
                    align="start"
                    justify="between"
                    pad="10px"
                >
                    <Text size="15px" margin="1px" alignSelf="center">
                        <GroupTitle gname={gname} />
                        <Text size="13px" margin="1px">
                            {" (" + groupData[gname].length + ")"}
                        </Text>
                    </Text>
                    <Button
                        plain
                        onClick={() => setOpen(!open)}
                        hoverIndicator={true}
                        icon={
                            open ? (
                                <BsChevronContract size="12px" />
                            ) : (
                                <BsChevronExpand size="12px" />
                            )
                        }
                    />
                </Box>
                <Box width="full" align="start">
                    {open && (
                        <BookList
                            booklist={groupData[gname]}
                            sortoption={"year"}
                        />
                    )}
                </Box>
            </Box>
        );
    };
    const [openAll, setOpenAll] = React.useState(true);
    const [openNone, setOpenNone] = React.useState(false);

    return (
        <Box direction="column" align="start" justify="start">
            <Box
                align="start"
                justify="between"
                width="full"
                height="50px"
                direction="row"
            >
                <Box
                    margin={{ horizontal: "30px", vertical: "10px" }}
                    focusIndicator={false}
                    direction="row"
                    align="center"
                    justify="center"
                    background="rgb(255,255,255,0.8)"
                    round="2px"
                    style={{ maxHeight: "30px" }}
                >
                    {/* input filterText */}
                    <TextInput
                        size="xsmall"
                        plain
                        focusIndicator={false}
                        style={{ maxHeight: "30px" }}
                        placeholder={<Text size="10px">검색</Text>}
                        value={filterText}
                        onChange={(e) => setFilterText(e.currentTarget.value)}
                    ></TextInput>
                    <Button
                        plain
                        size="13px"
                        icon={<Close size="10px" />}
                        onClick={() => setFilterText("")}
                    />
                    <Text
                        size="12px"
                        color="grey"
                        margin={{ horizontal: "10px" }}
                    >
                        |
                    </Text>
                    <Button
                        plain
                        size="15px"
                        icon={<Search size="13px" />}
                        margin={{ right: "10px" }}
                        onClick={() => setFilterText(filterText)}
                    />
                </Box>
                <Box direction="row">
                    <Button
                        plain
                        onClick={() => (setOpenAll(true), setOpenNone(false))}
                        icon={<BsChevronExpand size="15px" color="white" />}
                    />
                    <Button
                        plain
                        onClick={() => (setOpenAll(false), setOpenNone(true))}
                        icon={<BsChevronContract size="15px" color="white" />}
                    />
                </Box>
            </Box>
            <Box
                width="full"
                height="full"
                margin={{ top: "5px" }}
                align="start"
                justify="start"
                overflow={"scroll"}
                direction="column"
            >
                {groupFiltered.map((g: any) => (
                    <Box
                        key={g}
                        width="full"
                        margin="1px"
                        pad={{ horizontal: "15px" }}
                        style={{ minHeight: "50px" }}
                        flex={false}
                        align="start"
                        justify="start"
                    >
                        <GroupUnit gname={g} open={openAll} close={openNone} />
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default BookGroupList;
